import { EventEmitter } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var LineChartComponent = /** @class */ (function () {
    function LineChartComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.results = [];
        this.xAxis = true;
        this.yAxis = true;
        this.autoScale = true;
        this.isDateFormat = false;
        this.scheme = {
            domain: [
                '#0054ff', '#ff3365', '#f9bb42', '#00194a', '#b0bacf', '#12b886', '#58595b'
            ]
        };
        this.select = new EventEmitter();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    return LineChartComponent;
}());
export { LineChartComponent };
